// mutations
export const SET_BASIC_INFO = "SET_BASIC_INFO";
export const SET_EXTEND_INFO = "SET_EXTEND_INFO";
export const SET_DETAIL_EMPTY_INFO = "SET_DETAIL_EMPTY_INFO";

// getters
export const GET_BASIC_INFO_FORM = "GET_BASIC_INFO_FORM";
export const GET_EXTEND_INFO_FORM = "GET_EXTEND_INFO_FORM";
